import { Col } from "antd";
import { DetailStatisticCard } from "./DetailStatisticCard";
import { ChatCircleDotsIcon } from "@phosphor-icons/react";
import { useCustom, useTranslate } from "@refinedev/core";
import { useSearchParams } from "react-router-dom";
import { ChatSummaryStats } from "types/";
import { ANALYTICS_STALE_TIME, TARGETS } from "./constants/constants";
import { analyticsTheme } from "./analyticsTheme";
import { useAnalyticsBackState } from "../../projects/hooks/useAnalyticsBack";

const T_PREFIX = "media.projects.analytics.dashboard.summaryCards.aiChatbot";

interface ChatbotSummaryProps {
  projectId: string;
}

export const ChatbotSummary: React.FC<ChatbotSummaryProps> = ({
  projectId,
}) => {
  const t = useTranslate();
  const [searchParams] = useSearchParams();
  const backState = useAnalyticsBackState();
  const {
    data: chatSummary,
    isLoading: isChatSummaryLoading,
    isFetching: isChatSummaryFetching,
  } = useCustom<ChatSummaryStats>({
    url: `analytics/projects/${projectId}/analytics/chat/summary`,
    method: "get",
    queryOptions: {
      enabled: !!projectId,
      staleTime: ANALYTICS_STALE_TIME,
    },
    errorNotification: false,
  });

  const chatData = chatSummary?.data;

  return (
    <Col sm={24} md={8}>
      <DetailStatisticCard
        icon={<ChatCircleDotsIcon size={18} weight="fill" />}
        iconColor={analyticsTheme.datasetCyan}
        title={t(`${T_PREFIX}.title`).toUpperCase()}
        loading={isChatSummaryLoading || isChatSummaryFetching}
        metrics={[
          {
            title: t(`${T_PREFIX}.chatRate`).toUpperCase(),
            metric: chatData?.chat_rate_pct,
            type: "percentage",
            target: TARGETS.aiChatbot.chat_rate_pct,
            aim: "high",
          },
          {
            title: t(`${T_PREFIX}.avgMessages`).toUpperCase(),
            metric: chatData?.avg_messages_sent,
          },
          {
            title: t(`${T_PREFIX}.convinced`).toUpperCase(),
            metric: chatData?.convinced_sessions,
          },
          {
            title: t(`${T_PREFIX}.sourceClicks`).toUpperCase(),
            metric: chatData?.total_source_clicks,
          },
        ]}
        to={`./ai-chatbot?${searchParams.toString()}`}
        replace
        state={backState}
        className={"ai-chatbot-card"}
      />
    </Col>
  );
};
